import ImportRepository from "./importRepository";
import dmsRepository from "./dmsRepository";
import MasterRepository from "./masterRepository";
import PriceItemRepository from "./priceItemRepository";
import PricingManagementV3Repository from "./pricingManagementV3Repository";
import salesReturnV2Repository from "./salesReturnV2Repository";
import mobilePreparationRepository from "./mobilePreparationRepository";
import approvalRepository from "./approvalRepository";

const repositories = {
  master: MasterRepository,
  pricingManagementV3: PricingManagementV3Repository,
  import: ImportRepository,
  salesReturnV2: salesReturnV2Repository,
  dms: dmsRepository,
  mobilePreparation: mobilePreparationRepository,
  priceItem: PriceItemRepository,
  approval: approvalRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
